module.exports = __webpack_public_path__ + "img/20190706154136QQ截图20190705091435.5dd11c96.png";